import App from './App.svelte';
import './stylesheets/global.scss';
const app = new App({
    target: document.getElementById('svgmap-wrapper')
});
export default app;
/* TODO: second entry point
const app2 = new App({
    target: document.getElementById('svgmap-wrapper')
});

export default app;
*/
